import { type IntlFormatters } from 'react-intl';

import { SendingSource, SendingSourceErrorType, SendingSourceStatus, SendingSourceVerifiedType } from './types';

export const CUSTOM_EMAIL_SUBDOMAIN = 'up2rent';

export const UP2RENT_NO_REPLY_EMAIL = 'no-reply@up2rent.com';

const PRODUCTION_STAGE = 'app';

export const getDefaultSendingEmail = (environment: string) =>
  environment === PRODUCTION_STAGE ? UP2RENT_NO_REPLY_EMAIL : `no-reply@${environment}.up2rent.com`;

export const getSendingSourceStatusName = (
  status: SendingSourceStatus,
  verifiedType: SendingSourceVerifiedType,
  formatMessage: IntlFormatters['formatMessage']
) => {
  if (isSendingSourceDefault(verifiedType) && status === SendingSourceStatus.VERIFIED) {
    return formatMessage({ id: `settings.sendingSources.status.active` });
  }
  return formatMessage({ id: `settings.sendingSources.status.${status.toLowerCase()}` });
};

export const isSendingSourceDefault = (verifiedType: SendingSourceVerifiedType) =>
  verifiedType === SendingSourceVerifiedType.DEFAULT;

export const isSendingSourcePlatform = (verifiedType: SendingSourceVerifiedType) =>
  verifiedType === SendingSourceVerifiedType.PLATFORM;

export const getPlatformSendingSource = (sendingSources?: SendingSource[] | null) =>
  sendingSources?.find((sendingSource) =>
    isSendingSourcePlatform(sendingSource.verifiedType as SendingSourceVerifiedType)
  );

export const getEffectiveSendingSource = (sendingSources?: SendingSource[] | null): SendingSource | undefined => {
  const verifiedSendingSources = (sendingSources ?? []).filter(
    (sendingSource) => sendingSource.status === SendingSourceStatus.VERIFIED
  );
  const customSendingSource = verifiedSendingSources.find((sendingSource) =>
    isSendingSourceDefault(sendingSource.verifiedType as SendingSourceVerifiedType)
  );
  return customSendingSource ?? getPlatformSendingSource(verifiedSendingSources);
};

export enum SendingSourceMessageType {
  REMINDER = 'REMINDER',
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS',
  CRASH = 'CRASH',
}

export const getDefaultSendingSource = (sendingSources?: SendingSource[] | null) =>
  sendingSources?.find((sendingSource) =>
    isSendingSourceDefault(sendingSource.verifiedType as SendingSourceVerifiedType)
  );

export const isSendingSourceWellConfigured = (activeSendingSource?: SendingSource) =>
  !activeSendingSource || activeSendingSource.errorMessage !== SendingSourceErrorType.CRASH;
